export default {
  // 検索エリア
  batchSn: 'コードバッチ',
  batchSnPlaceholder: 'コードバッチを入力してください',
  qrcode: 'QRコード',
  qrcodePlaceholder: 'QRコードを入力してください',
  // テーブル列
  colBatchSn: 'コードバッチ',
  colName: 'バッチ名',
  colCodeRange: 'QRコード区間',
  colCodeCount: 'QRコード数量',
  colCodeRemark: 'バッチ説明',
  colStatus: '状態',
  colCreatedAt: '作成日時',
  colUpdatedAt: '更新日時',
  colRemark: '備考',
  colAction: '操作',
  // 操作
  editRemark: '備考を編集',
  // 備考編集ポップアップ
  editRemarkTitle: '備考を編集',
  remark: '備考',
  remarkPlaceholder: '備考内容を入力してください',
  // 空状態
  emptyText: 'コードバッチデータがありません',
};
